export default __webpack_public_path__ + "static/media/profile.06b78fe7.png";